import { useState } from 'react'
import { AgGridColumn } from 'ag-grid-react'
import { LinkButton } from 'Components/Ui-Kits/LinkButton'
import { PreviewConfirm } from 'Components/Shared/PreviewConfirm'
import { useAppTranslation } from 'i18n/hooks'
import { object, string } from 'prop-types'
import { usePendingReceptionsForAssignedUser } from 'data/receptions'
import { isPurchaseReception } from 'Components/Reception/receptionType'
import { receptionSendProposal } from 'api'
import { adminResendReceptionPending } from 'cloudFunctions'
import { useSnackbar } from 'notistack'
import { ReceptionStatusGrid } from '../ReceptionStatusGrid'

const ReminderButton = ({ data }) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const { t } = useAppTranslation()
  const { enqueueSnackbar } = useSnackbar()

  if (!isPurchaseReception(data)) return null

  const getPreview = () => receptionSendProposal(data.id)

  const handleConfirm = () => {
    setLoading(true)
    setOpen(false)
    adminResendReceptionPending(data.id)
      .then(() => enqueueSnackbar(t('reminderWasSent'), { variant: 'success' }))
      .catch(() => enqueueSnackbar(t('error'), { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  return (
    <>
      {open && (
        <PreviewConfirm
          onConfirm={handleConfirm}
          onClose={() => setOpen(false)}
          getPreview={getPreview}
          title={t('sendReminder')}
          open={open}
        />
      )}
      <LinkButton loading={loading} onClick={() => setOpen(true)} size="small">
        {t('sendReminder')}
      </LinkButton>
    </>
  )
}

ReminderButton.propTypes = {
  data: object,
}

export const PendingReceptions = ({ email }) => {
  const [receptions = [], loading] = usePendingReceptionsForAssignedUser(email)
  const { t } = useAppTranslation()

  return (
    <ReceptionStatusGrid
      title={t('pendingReceptionsAssignedToMe')}
      receptions={receptions}
      loading={loading}
      extraFrameworkComponents={{ reminder: ReminderButton }}
    >
      <AgGridColumn headerName={t('remind')} cellRenderer="reminder" sortable={false} />
    </ReceptionStatusGrid>
  )
}

PendingReceptions.propTypes = {
  email: string,
}
